function injectStyle (ssrContext) {
  require("!!../node_modules/_extract-text-webpack-plugin@3.0.2@extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"sourceMap\":true}!../node_modules/_vue-loader@13.7.1@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6a76983c\",\"scoped\":false,\"hasInlineConfig\":false}!px2rem-loader?{\"remUnit\":75}!../node_modules/_vux-loader@1.2.8@vux-loader/src/after-less-loader.js!less-loader?{\"sourceMap\":true}!../node_modules/_vux-loader@1.2.8@vux-loader/src/style-loader.js!../node_modules/_vue-loader@13.7.1@vue-loader/lib/selector?type=styles&index=0!./App.vue")
}
var normalizeComponent = require("!../node_modules/_vue-loader@13.7.1@vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../node_modules/_vux-loader@1.2.8@vux-loader/src/script-loader.js!../node_modules/_vux-loader@1.2.8@vux-loader/src/script-loader.js!../node_modules/_vue-loader@13.7.1@vue-loader/lib/selector?type=script&index=0!./App.vue"
import __vue_script__ from "!!babel-loader!../node_modules/_vux-loader@1.2.8@vux-loader/src/script-loader.js!../node_modules/_vue-loader@13.7.1@vue-loader/lib/selector?type=script&index=0!./App.vue"
/* template */
import __vue_template__ from "!!../node_modules/_vue-loader@13.7.1@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6a76983c\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../node_modules/_vux-loader@1.2.8@vux-loader/src/before-template-compiler-loader.js!../node_modules/_vux-loader@1.2.8@vux-loader/src/template-loader.js!../node_modules/_vue-loader@13.7.1@vue-loader/lib/selector?type=template&index=0!./App.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = null
// module chunks = 